import * as React from 'react';
import { VaiIcon } from '@vaisala/rockhopper-design-tokens';
import { Id } from '../../utils/ids.js';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { Paper } from '../Paper/Paper.js';
import './Login.scss.js';
import { Icon } from '../Icon/Icon.js';
import { UsernameAndPasswordForm } from './UsernameAndPasswordForm.js';
import { PasswordForm } from './PasswordForm.js';
import { UsernameForm } from './UsernameForm.js';
import { Accordion } from '../Accordion/Accordion.js';
import { Anchor } from '../Anchor/Anchor.js';

const bem = Bem.create("vai-login");
class Login extends React.Component {
  constructor() {
    super(...arguments);
    this.state = { isHelpOpen: false };
    this.handleHelpExpand = (isOpen) => {
      this.setState({ isHelpOpen: isOpen });
    };
  }
  render() {
    const {
      htmlId,
      dataTa,
      productName,
      error,
      children,
      privacyPolicyUrl,
      privacyPolicyText,
      productVersion,
      className,
      copyright,
      helpTitle,
      helpContents
    } = this.props;
    const id = Id.create(htmlId, ["login"]).toString();
    return /* @__PURE__ */ React.createElement("div", {
      id,
      className: addClass(bem.block(), className),
      "data-ta": dataTa
    }, /* @__PURE__ */ React.createElement("span", {
      className: bem.element("logo")()
    }), productName && /* @__PURE__ */ React.createElement("span", {
      className: bem.element("product-name")()
    }, productName), /* @__PURE__ */ React.createElement("div", {
      className: bem.element("children")()
    }, error && /* @__PURE__ */ React.createElement(Paper, {
      className: bem.element("error")()
    }, /* @__PURE__ */ React.createElement(Icon, {
      name: VaiIcon.Warning,
      className: bem.element("error-icon")()
    }), error), /* @__PURE__ */ React.createElement(Paper, {
      className: bem.element("paper")()
    }, children), helpTitle && helpContents && /* @__PURE__ */ React.createElement(Paper, {
      className: bem.element("help")()
    }, /* @__PURE__ */ React.createElement(Accordion, {
      title: /* @__PURE__ */ React.createElement(React.Fragment, null, helpTitle),
      isExpanded: this.state.isHelpOpen,
      onChangeAccordionExpanded: this.handleHelpExpand
    }, helpContents)), /* @__PURE__ */ React.createElement("div", {
      className: bem.element("app-meta")()
    }, privacyPolicyUrl && privacyPolicyText && /* @__PURE__ */ React.createElement(Anchor, {
      className: bem.element("app-meta-privacy-policy")(),
      openInNewWindow: true,
      to: privacyPolicyUrl
    }, privacyPolicyText), productVersion && /* @__PURE__ */ React.createElement("p", {
      className: bem.element("app-meta-product-version")()
    }, productVersion))), /* @__PURE__ */ React.createElement("span", {
      className: bem.element("copyright")()
    }, copyright));
  }
}
Login.UsernameForm = UsernameForm;
Login.PasswordForm = PasswordForm;
Login.UsernameAndPasswordForm = UsernameAndPasswordForm;
Login.defaultProps = {
  privacyPolicyUrl: "https://www.vaisala.com/en/vaisala-policies",
  privacyPolicyText: "Privacy Policy",
  copyright: "\xA9 Vaisala - All rights reserved",
  formTitle: "Login",
  dataTa: "vai-login"
};

export { Login };
